<template>
  <LoadingSpinner v-if="loading" />
  <PostSigning
    v-else
    :heading="$t('widgetSigned.needToVerify')"
    :messageIntro="$t('widgetSigned.needToVerifyMessageIntro')"
    :message="$t('widgetSigned.needToVerifyMessage')"
    type="warning"
  />
</template>

<script setup>
// @ts-check
import { defineProps } from 'vue'
import { useSignedData } from '@/composables/useSignedData'

import PostSigning from '@/components/screens/PostSigningScreen.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const props = defineProps({
  widgetCode: {
    type: String,
    required: true
  }
})

const { loading } = useSignedData({ widgetCode: props.widgetCode })
</script>
